import styled from '@emotion/styled';
import { COLORS3 as COLORS, FONT, MEDIA_QUERY, SPACING } from '../../styles/emotion';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 64px 1fr;

  ${MEDIA_QUERY.DESKTOP_XL} {
    grid-template-columns: 80px 1fr;
  }
`;

export const ImageWrapper = styled.div`
  align-self: center;
  background-color: ${COLORS.BLACK_015};
  border-radius: 81px;
  height: 64px;
  overflow: hidden;
  width: 64px;

  ${MEDIA_QUERY.DESKTOP_XL} {
    border-radius: 100px;
    height: 80px;
    width: 80px;
  }
`;

export const Image = styled.img`
  width: 100%;
`;

export const TextWrapper = styled.div`
  color: inherit;
  display: flex;
  flex-flow: column;
  padding-left: ${SPACING.S16};

  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    padding-left: 12px;
  }
`;

export const Quote = styled.div`
  font-size: ${FONT.FONT_SIZE_SMALLER};
  line-height: ${FONT.FONT_SIZE_REGULAR};
  font-weight: ${FONT.FONT_WEIGHT_REGULAR};
  max-width: 262px;

  ${MEDIA_QUERY.DESKTOP_XL} {
    font-size: ${FONT.FONT_SIZE_SMALL};
    line-height: ${FONT.FONT_SIZE_LARGE};
  }

  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    max-width: 210px;
  }
`;

export const Names = styled.p`
  color: inherit;
  font-size: ${FONT.FONT_SIZE_SMALLER};
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  line-height: ${FONT.FONT_SIZE_REGULAR};
  padding-top: ${SPACING.XS};

  ${MEDIA_QUERY.DESKTOP_XL} {
    font-size: ${FONT.FONT_SIZE_SMALL};
    line-height: ${FONT.FONT_SIZE_LARGE};
  }
`;
